/**
 * 公式计算用户端：
 * 引入改组件需要提供以下数据
 * formList，
 * formData,
 * modObj 下 calOrderMap
 */

export default {
    data () {
        return {
            flowUrl: {
                module: "approve",
                name: "taskCalculate"
            }
        };
    },
    computed: {
        caculatorObj () {
            let caculatorList = this.curScreenFormList || this.formList || [];
            let caculatorObj = caculatorList.reduce((obj, caculatorItem) => {
                return {
                    ...obj,
                    [caculatorItem._key]: {
                        _type: caculatorItem._type,
                        caculatorList: [], // 该字段改变影响的其他字段
                        needCaculatorFields: []// 该字段下需要计算的字段，仅针对内部表格等使用
                    }
                };
            }, {});

            let loop = (list, parentKey) => {
                list.forEach(caculatorItem => {
                    if (["calculate", "calculateInput"].includes(caculatorItem._enterType)) {
                        let variables = caculatorItem._calculate && caculatorItem._calculate._variables;
                        if (variables.length) {
                            variables.forEach(variable => {
                                let relyKey = variable._fields && variable._fields[0];
                                relyKey === "THIS" && (relyKey = parentKey);
                                if (relyKey && caculatorObj[relyKey]) {
                                    let relativeKey = parentKey ? `${parentKey}__${caculatorItem._key}` : caculatorItem._key;
                                    // 该字段下影响的字段
                                    caculatorObj[relyKey].caculatorList.push(relativeKey);
                                    // 该字段下需要计算的字段
                                    if (variable._fields[1] && (relyKey !== parentKey)) {
                                        caculatorObj[relyKey].needCaculatorFields.push(variable._fields.join("__"));
                                    }
                                } else {
                                    // this.$Message.error("公式配置错误");
                                }
                            });
                        }
                    }
                    if (caculatorItem._type === "flatTable") {
                        loop(caculatorItem._subForm, caculatorItem._key);
                    }
                });
            };
            loop(caculatorList);
            return caculatorObj;
        },
        calOrderMap () {
            return this.modObj ? this.modObj.calOrderMap : {};
        }
    },
    created () {},
    methods: {
        relatedChange (formItem, ...params) {
            let subKey;
            if (formItem._type === "flatTable") {
                subKey = params && params[2] && params[2]._key;
            } else if (formItem._type === "cascaderTable") {
                subKey = params && params[2] && params[2]._key;
            }

            let currentKey = subKey ? `${formItem._key}__${subKey}` : formItem._key;

            if (this.calOrderMap[currentKey]) {
                this.getCacluate([currentKey]);
                return;
            }
            /**
             * 特殊类型 走接口
             * 1、内部表格添加或删除一条数据走接口
             * 2、单条关联触发接口
             */
            if ((["flatTable", "cascaderTable", "reference", "referenceBy"].includes(formItem._type)) && this.caculatorObj[formItem._key].needCaculatorFields.length) {
                this.getCacluate(this.caculatorObj[formItem._key].needCaculatorFields);
            }
        },
        // 流程change
        relatedFlowChange (formItem, ...params) {
            let subKey;
            if (formItem._type === "flatTable") {
                subKey = params && params[2] && params[2]._key;
            } else if (formItem._type === "cascaderTable") {
                subKey = params && params[2] && params[2]._key;
            }

            const urlParams = {
                task: this.taskId,
                flowDefKey: this.taskId ? undefined : this.flowDefKey
            };

            let currentKey = subKey ? `${formItem._key}__${subKey}` : formItem._key;

            if (this.calOrderMap[currentKey]) {
                this.getCacluate([currentKey], this.flowUrl, urlParams);
                return;
            }
            /**
             * 特殊类型 走接口
             * 1、内部表格添加或删除一条数据走接口
             * 2、单条关联触发接口
             */
            if ((["flatTable", "cascaderTable", "reference", "referenceBy"].includes(formItem._type)) && this.caculatorObj[formItem._key].needCaculatorFields.length) {
                this.getCacluate(this.caculatorObj[formItem._key].needCaculatorFields, this.flowUrl, urlParams);
            }
        },
        // 重新获取所有表单的值
        getCacluate (changeFields, url, params = {}) {
            this.$https({
                url: url || {
                    ...this.urlParams,
                    name: "customCalculate"
                },
                params: {
                    ...this.formData,
                    changeFields: changeFields,
                    ...(this.isCreate ? { _id: undefined } : {}),
                    ...params
                },
                callback: data => {
                    let caculatorObj = this.caculatorObj;
                    for (let attr in data) {
                        if (caculatorObj[attr] && caculatorObj[attr]._type === "flatTable") {
                            if (this.formData[attr].list.length !== data[attr].list.length) {
                                this.formData[attr].list = data[attr].list;
                            } else {
                                this.loop(this.formData[attr].list, data[attr].list);
                            }
                        } else if (caculatorObj[attr] && caculatorObj[attr]._type === "cascaderTable") {
                            if (this.formData[attr].tree.length !== data[attr].tree.length) {
                                this.formData[attr].tree = data[attr].tree;
                            } else {
                                this.loop(this.formData[attr].tree, data[attr].tree);
                            }
                        } else {
                            this.formData[attr] = data[attr];
                        }
                    }
                },
                error: response => {
                    this.$Message.error("公式计算错误");
                }
            });
        },

        // 新增时数据的初始化处理
        formDataCreateInit () {
            if (this.isCreate) {
                this.curScreenFormList.forEach(formItem => {
                    // if (formItem._type === "cascaderTable") {
                    //     this.formData[formItem._key] && this.loop(this.formData[formItem._key].tree, null, formItem._subForm);
                    // } else
                    if (formItem._type === "coordinates" && formItem._autoLocation) {
                        // 在添加模式下自动获取当前位置
                        AMap.plugin(["AMap.Geolocation"], () => {
                            new AMap.Geolocation().getCurrentPosition((status, result) => {
                                if (status == "complete" && result.info == "SUCCESS") {
                                    this.formData[formItem._key] = {
                                        name: result.formattedAddress,
                                        lnglat: [[result.position.lng, result.position.lat]]
                                    };
                                }
                            });
                        });
                    }
                });
            }
        },
        loop (nodes, data, subForm, isSet = false) {
            nodes.forEach((node, nodeIdx) => {
                if (node.children && node.children.length && data) {
                    // 增删数据处理
                    if (node.children.length != data[nodeIdx].children.length) {
                        this.$set(node, "children", data[nodeIdx].children);
                    } else {
                        this.loop(node.children, data[nodeIdx].children);
                    }
                } else if (!data) {
                    this.$set(nodes, nodeIdx, nodes[nodeIdx]);

                    if (node.children && node.children.length) {
                        this.loop(node.children, null, subForm);
                    } else if (subForm) {
                        // 赋初始值
                        subForm.forEach(formItem => {
                            this.$set(node, formItem._key, node[formItem._key]);
                        });
                    }

                } else {
                    let subData = data[nodeIdx];

                    isSet && this.$set(nodes, nodeIdx, nodes[nodeIdx]);

                    for (let subAttr in subData) {
                        if ((subAttr.slice(0, 4) === "FIE_") && (node[subAttr] != subData[subAttr])) {
                            this.$set(node, subAttr, subData[subAttr]);
                        }
                    }
                }
            });
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/base/sheetCalcuMixin.js